import { Divider, Text } from '@chakra-ui/react';

function OrDivider() {
    return (
        <div
            style={{
                width: '100%',
                marginTop: '24px',
                marginBottom: '24px',
                display: 'block',
                textAlign: 'center'
            }}
        >
            <Text
                display="inline"
                bg="white"
                padding="8px"
                fontWeight="600"
                fontSize="12px"
                letterSpacing="1px"
                position="relative"
                color="gray.600"
                zIndex="2"
            >
                OR
            </Text>
            <Divider zIndex="1" position="relative" top="-11px" />
        </div>
    );
}

export default OrDivider;
